import { createSlice } from "../helper";

const initialState = {
  eventIdRsvpStatusMap: {},
  eventIdReminderMap: {},
  refreshCalendar: false,
  refreshQuickView: false,
  page: 0,
  reRenderTabContentCounter: 0
}

const eventsListingSlice = createSlice({
  name: "eventsListing",
  initialState,
  reducers: {
    replaceEvents: (_state, action) => {
      return {
        ...initialState,
        ...action.payload
      };
    },
    updateIsCalendarView: (state, action) => {
      state.isCalendarView = action.payload;
    },
    updateTab: (state, action) => {
      state.filters.tab = action.payload;
    },
    updateMeetingMode: (state, action) => {
      state.filters.meetingMode = action.payload;
    },
    updatePrograms: (state, action) => {
      state.filters.programs = action.payload;
    },
    setQuickViewEventId: (state, action) => {
      state.quickViewEventId = action.payload;
    },
    updateEventIdRsvpStatusMap: (state, action) => {
      state.eventIdRsvpStatusMap[action.payload.eventId] = action.payload.rsvpStatus;
    },
    updateEventIdReminderMap: (state, action) => {
      state.eventIdReminderMap[action.payload.eventId] = action.payload.reminder;
    },
    updateRefreshCalendar: (state, action) => {
      state.refreshCalendar = action.payload;
    },
    updateRefreshQuickView: (state, action) => {
      state.refreshQuickView = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    updateCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
    incrementReRenderTabContentCounter: state => {
      state.reRenderTabContentCounter += 1;
    }
  }
});

export const eventsListingActions = eventsListingSlice.actions;

export default eventsListingSlice.reducer;
